import { EntityType } from 'app/agriculture/models/Entities';
import { tanksRouteConfig } from 'app/agriculture/routes/Tanks/tanksRouteConfig';
import { devicesRouteConfig } from 'app/agriculture/routes/Devices/devicesRouteConfig';
import { herdsRouteConfig } from 'app/agriculture/routes/Herds/herdsRouteConfig';
import { notesRouteConfig } from 'app/agriculture/routes/Notes/notesRouteConfig';
import { tasksRouteConfig } from 'app/agriculture/routes/Tasks/tasksRouteConfig';
import { RouteConfig } from 'app/agriculture/router/types';
import { protagAnimalRouteConfig } from 'app/agriculture/routes/ProtagAnimal/protagAnimalRouteConfig';
import { infraRouteElements } from 'app/agriculture/routes/Infra/infraRouteConfig';

export const routeConfig: Record<EntityType, RouteConfig> = {
    Boundary: {
        rootPath: 'boundaries',
        routeElements: infraRouteElements('Boundary'),
    },
    'Bridge Crossing': {
        rootPath: 'bridge-crossings',
        routeElements: infraRouteElements('Bridge Crossing'),
    },
    'Cool Room': {
        rootPath: 'cool-rooms',
        routeElements: infraRouteElements('Cool Room'),
    },
    Dam: {
        rootPath: 'dams',
        routeElements: infraRouteElements('Dam'),
    },
    Device: devicesRouteConfig,
    'Erosion Area': {
        rootPath: 'erosion-areas',
        routeElements: infraRouteElements('Erosion Area'),
    },
    ProtagAnimal: protagAnimalRouteConfig,
    Fence: {
        rootPath: 'fences',
        routeElements: infraRouteElements('Fence'),
    },
    Gate: {
        rootPath: 'gates',
        routeElements: infraRouteElements('Gate'),
    },
    Herd: herdsRouteConfig,
    House: {
        rootPath: 'houses',
        routeElements: infraRouteElements('House'),
    },
    Trough: {
        rootPath: 'troughs',
        routeElements: infraRouteElements('Trough'),
    },
    Note: notesRouteConfig,
    Paddock: {
        rootPath: 'paddocks',
        routeElements: infraRouteElements('Paddock'),
    },
    Shed: {
        rootPath: 'sheds',
        routeElements: infraRouteElements('Shed'),
    },
    Silo: {
        rootPath: 'silos',
        routeElements: infraRouteElements('Silo'),
    },
    Tank: tanksRouteConfig,
    Task: tasksRouteConfig,
    Vegetation: {
        rootPath: 'vegetation',
        routeElements: infraRouteElements('Vegetation'),
    },
    Waterway: {
        rootPath: 'waterways',
        routeElements: infraRouteElements('Waterway'),
    },
    Yard: {
        rootPath: 'yards',
        routeElements: infraRouteElements('Yard'),
    },
};
